import { pickLocale, type StaticCharacteristic } from '../../schema';
import { HtmlContent } from '../HtmlContent';

interface StaticViewProps {
    characteristic: StaticCharacteristic;
    locale: string | undefined;
}

/**
 * Renders the admin-authored HTML content. The source is trusted: only the
 * customer's own admin users can write static blocks, and they're shown in
 * the same security context as the rest of the bundle. We still scope it
 * under .cfg-static so any element styles don't bleed into the host page.
 *
 * Empty content renders nothing — merchants sometimes leave a static block
 * as a deliberate spacer or pending edit, and a fallback "no content"
 * message in storefront/preview would be noise.
 */
export function StaticView({ characteristic, locale }: StaticViewProps) {
    const html = pickLocale(characteristic.defaultValue, locale) ?? '';
    if (html.length === 0) return null;
    return <HtmlContent className="cfg-static" html={html} />;
}
